import React, { Fragment } from "react";
import classes from "./Filter.module.css";
import getPkmn from "../../Assets/Data/Pokedex"; 
import NatureName from "../../Util/NatureName";
import AbilityName from "../../Util/AbilityName";
import {judgeNames} from "../../Util/JudgeNames";
import ReactDOMServer from 'react-dom/server';
import { useTranslation } from 'react-i18next';

const ToxtricityAmplifiedNatures = [0x03, 0x04, 0x02, 0x08, 0x09, 0x13, 0x16, 0x0B, 0x0D, 0x0E, 0x18];
const ToxtricityLowKeyNatures = [0x01, 0x05, 0x07, 0x0A, 0x0C, 0x0F, 0x10, 0x11, 0x12, 0x14, 0x15, 0x17];

function compare(a, b) {
    return a.props.label > b.props.label ? 1 : b.props.label > a.props.label ? -1 : 0;
  }

const Filter = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation();

    const STATS = [t("stats.HP"), t("stats.ATK"), t("stats.DEF"), t("stats.SPA"), t("stats.SPD"), t("stats.SPE") ];
    const Gender = ["\u2642", "\u2640", "-"];

    let filterOptions = null;
    let natureList = null;
    let abilityList = null;
    let genderList = null;
    if (props.currentSelectedPokemon) {
        const pkmn = props.currentSelectedPokemon;
        let natureWorkList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24].map(num => <NatureName id={num} />);
        if (pkmn.Species === 849) {
            if (pkmn.AltForm === 0) {
                natureWorkList = ToxtricityAmplifiedNatures.map(num => <NatureName id={num} />);
            } else {
                natureWorkList = ToxtricityLowKeyNatures.map(num => <NatureName id={num} />);
            }
        }
        natureWorkList = natureWorkList.map(n => ReactDOMServer.renderToStaticMarkup(n));

        natureList = [<option key={"nany"} value="-1">{t("misc:OPTIONANY")}</option>].concat((natureWorkList.map((n, i) => {
            return <option key={"n"+i} value={i} label={n}>{n}</option>
        }).sort(compare)));

        const pkmnData = getPkmn(pkmn.Species, pkmn.AltForm);
        const abilities = pkmnData.Abilities.map(num => ReactDOMServer.renderToStaticMarkup(<AbilityName id={num} />));
        if(pkmn.Ability < 3) {
            abilityList = <option key={"a"+pkmn.Ability} value={pkmn.Ability}>{abilities[pkmn.Ability]}</option>
        } else if(pkmn.Ability === 3) {
            if(pkmnData.Abilities[0] === pkmnData.Abilities[1]) {
                abilityList = <option key="a-2" value="-2">{abilities[0]}</option>
            } else {
                abilityList = <Fragment>
                        <option key="a-1" value="-1">{t("misc:OPTIONANY")}</option>
                        <option key="a0" value="0">{abilities[0]}</option>
                        <option key="a1" value="1">{abilities[1]}</option>
                    </Fragment>
            }
        } else {
            if(pkmnData.Abilities[0] === pkmnData.Abilities[1] && pkmnData.Abilities[1] === pkmnData.Abilities[2]) {
                abilityList = <option key="a-1" value="-1">{abilities[0]}</option>
            } else if(pkmnData.Abilities[0] === pkmnData.Abilities[1]) {
                abilityList = <Fragment>
                    <option key="a-1" value="-1">{t("misc:OPTIONANY")}</option>
                    <option key="a-2" value="-2">{abilities[0]}</option>
                    <option key="a2" value="2">{abilities[2]}</option>
                </Fragment>
            } else {
                abilityList = <Fragment>
                    <option key="a-1" value="-1">{t("misc:OPTIONANY")}</option>
                    <option key="a-2" value="-2">{t("misc:ABILITYNORMAL")}</option>
                    <option key="a0" value="0">{abilities[0]}</option>
                    <option key="a1" value="1">{abilities[1]}</option>
                    <option key="a2" value="2">{abilities[2]}</option>
                </Fragment>
            }
        }

        if (pkmnData.Gender === 255) {
            genderList = <option key="2" value="2">{Gender[2]}</option>
        } else if (pkmnData.Gender === 254) {
            genderList = <option key="1" value="1">{Gender[1]}</option>
        } else if (pkmnData.Gender === 0) {
            genderList = <option key="0" value="0">{Gender[0]}</option>
        } else {
            genderList = <Fragment>
                <option key="-1" value="-1">{t("misc:OPTIONANY")}</option>
                <option key="0" value="0">{Gender[0]}</option>
                <option key="1" value="1">{Gender[1]}</option>
            </Fragment>
        }

        const mode = props.judgeShow ? t("misc:JUDGEMODE") : t("misc:EXACTMODE");
        const switchMode = !props.judgeShow ? t("misc:JUDGEMODE") : t("misc:EXACTMODE");
        filterOptions = (
            <Fragment>
            <div className={classes.IVBox}>
                <strong>{t("misc:IVS")} ({mode})</strong> <span style={{"color": "#007bff", "fontSize": "small", "cursor": "pointer"}} onClick={props.judgeShowChange}>[{switchMode}]</span>
                {
                    STATS.map((val, idx) => {
                        return (<div key={val+idx} className={props.judgeShow ? classes.SelectElement : classes.InputRow}>
                            <span className={props.judgeShow ? classes.OtherTitle : classes.Title}>{val}</span>
                            {props.judgeShow ?
                            <select value={props.judgeIdx[idx]} className={classes.Select} onChange={e => props.judgeChange(e, idx)}>
                                {
                                judgeNames.map((v, i) => {
                                    return <option key={i} value={i}>{ReactDOMServer.renderToStaticMarkup(v)}</option>
                                })
                                }
                            </select>
                            :
                            <Fragment>
                                <input type="number" max="31" min="0" className={classes.InputField} size="3" value={props.filteredIVs[idx][0]} onChange={e => props.minIV(e, idx)}/> <span className={classes.InBetween}>-</span> 
                                <input type="number" max="31" min="0" className={classes.InputField} size="3" value={props.filteredIVs[idx][1]} onChange={e => props.maxIV(e, idx)}/>
                                <button className={classes.Button} onClick={e => props.setMin(idx)}>0-1 {t("misc:IVS")}</button>
                                <button className={classes.Button} onClick={e => props.setMax(idx)}>30-31 {t("misc:IVS")}</button>
                                <button className={classes.Button} onClick={e => props.setDefault(idx)}>0-31 {t("misc:IVS")}</button>
                            </Fragment>
                            }
                        </div>)
                    })
                }
            </div>
            <div className={classes.OtherBox}>
                <div className={classes.SelectElement}>
                    <span className={classes.OtherTitle}>{t("misc:NATURE")}</span>
                    <select className={classes.Select} value={props.nature} onChange={props.natureChange}>
                        {natureList}
                    </select>
                </div>
                <div className={classes.SelectElement}>
                    <span className={classes.OtherTitle}>{t("misc:ABILITY")}</span>
                    <select className={classes.Select}  value={props.ability} onChange={props.abilityChange}>
                        {abilityList}
                    </select>
                </div>
                <div className={classes.SelectElement}>
                    <span className={classes.OtherTitle}>{t("misc:GENDER")}</span>
                    <select className={classes.Select}  value={props.gender} onChange={props.genderChange}>
                        {genderList}
                    </select>
                </div>
                <div className={classes.SelectElement}>
                    <span className={classes.OtherTitle}>{t("misc:SHINYNESS")}</span>
                    <select className={classes.Select}  value={props.shiny} onChange={props.shinyChange}>
                        <option value="-1">{t("misc:OPTIONANY")}</option>
                        <option value="-2">{t("misc:SHINY")}</option>
                        <option value="0">{t("misc:SHINYNONE")}</option>
                        <option value="1">☆</option>
                        <option value="2">◇</option>
                    </select>
                </div>
            </div>
            </Fragment>
        )
    }
    return <div className={classes.Wrapper}>
        <strong>{t("misc:HEADERFILTER")}</strong>
        <div>
            {filterOptions}
        </div>
    </div>;
}

export default React.memo(Filter);